import React from 'react'
import { CFImage, CFView, DefaultScreen, MobileScreen } from 'components'
import { about, aboutParallel, mobileAbout, mobileAboutParallel } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center>
          <CFImage src={mobileAbout} w="100%" alt="The Rice Box About" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFImage src={about} w="100%" alt="The Rice Box About" />
      </DefaultScreen>
    </CFView>
  )
}
